import { useEffect } from "react";
import useAuthContext from "../hooks/useAuthContext";

function Logout() {
  const {logoutSession} = useAuthContext();
  useEffect(() => logoutSession());
  return null;
}

export default Logout;